import StepTwo from "@/components/dashboard/receive/StepTwo";

export default function ReceiveStepTwo() {
  return <StepTwo />;
}
